import { Injectable,Inject } from '@angular/core';
import { NB_WINDOW } from '@nebular/theme';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DimensionsService {

  //private iframeViewPortHeight = new Subject<number>()

  constructor(@Inject(NB_WINDOW) private window:Window) { }

  public viewPortHeight(body:HTMLElement):number{
    let headerHeight = 0;
    let headerElements = body.getElementsByTagName("NB-LAYOUT-HEADER");
    if(headerElements.length > 0){
      let headerHost = <HTMLElement>headerElements[0];
      headerHeight = headerHost.offsetHeight;
    }
    //const headerHeight = <number><any>styles.getPropertyValue('--header-height');
    const windowInnerHeight = this.window.innerHeight-headerHeight;
    return windowInnerHeight
  }

}
